export default [

     {
          path: '/objective-details/:id',
          name: 'ObjectiveDetails',
          component: () => import("@/views/Page/StrategicPlan/Objective/ObjectiveDetails.vue"),
           meta: {
               title: 'ObjectiveDetails',
          },
     }
];